import { Link } from "@tanstack/react-router";

export type GuiaRef = { slug: string; titulo: string; resumen: string };

export const GUIAS: Record<string, GuiaRef> = {
  "guia-hayedo-tejera-negra": {
    slug: "guia-hayedo-tejera-negra",
    titulo: "Hayedo de Tejera Negra: guía completa",
    resumen: "Parking, reserva de plaza, rutas y cuándo llega el color del otoño.",
  },
  "que-ver-sierra-norte-guadalajara": {
    slug: "que-ver-sierra-norte-guadalajara",
    titulo: "Qué ver en la Sierra Norte de Guadalajara",
    resumen: "Planes para un fin de semana completo en la sierra.",
  },
  "casa-rural-grupos-cerca-madrid": {
    slug: "casa-rural-grupos-cerca-madrid",
    titulo: "Casa rural para grupos cerca de Madrid",
    resumen: "Qué mirar antes de reservar cuando sois muchos.",
  },
  "arquitectura-negra": {
    slug: "arquitectura-negra",
    titulo: "Pueblos negros de Guadalajara",
    resumen: "Pizarra, tradición y arquitectura serrana pueblo a pueblo.",
  },
  "subida-alto-rey": {
    slug: "subida-alto-rey",
    titulo: "Subir al Pico Alto Rey paso a paso",
    resumen: "La ruta clásica desde Bustares hasta la ermita de la cumbre.",
  },
  "estrellas-alto-rey": {
    slug: "estrellas-alto-rey",
    titulo: "Observar estrellas en la Sierra del Alto Rey",
    resumen: "Cuándo ir, dónde mirar y qué llevar para ver la Vía Láctea.",
  },
};

export function GuiasRelacionadas({ slugs, titulo = "Guías de la zona" }: { slugs: string[]; titulo?: string }) {
  const items = slugs.map((s) => GUIAS[s]).filter(Boolean) as GuiaRef[];
  if (items.length === 0) return null;
  return (
    <section className="bg-secondary/40">
      <div className="mx-auto max-w-5xl px-4 py-16 md:px-6">
        <h2 className="font-serif text-2xl text-foreground md:text-3xl">{titulo}</h2>
        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {items.map((g) => (
            <Link
              key={g.slug}
              to="/blog/$slug"
              params={{ slug: g.slug }}
              className="group block rounded-sm border border-border bg-card p-5 transition-colors hover:border-primary/50"
            >
              <h3 className="font-serif text-lg text-foreground group-hover:text-primary">{g.titulo}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{g.resumen}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
